import type { Resource } from '../../';
export const product_details_unavailable: Resource = {"default":"Unavailable"};
